import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import * as React from 'react';
import classNames from 'classnames';
import { CheckIcon } from '../../../icons';
import { CheckboxView } from '../../../checkbox/view';
import * as styles from './selectPopupOption.css';
export var SelectPopupOption = /*#__PURE__*/function (_React$Component) {
  _inherits(SelectPopupOption, _React$Component);

  var _super = _createSuper(SelectPopupOption);

  function SelectPopupOption() {
    var _this;

    _classCallCheck(this, SelectPopupOption);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "handleClick", function (e) {
      _this.props.onClick(e, _this.props.index);
    });

    _defineProperty(_assertThisInitialized(_this), "handleMouseMove", function (e) {
      _this.props.onMouseMove(e, _this.props.index);
    });

    return _this;
  }

  _createClass(SelectPopupOption, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("div", {
        ref: this.props.forwardedRef,
        className: classNames(styles['option'], this.props.focused && styles['focused'], this.props.multiple && styles['multiple']),
        onClick: this.handleClick,
        onMouseMove: this.handleMouseMove
      }, this.renderIcon(), this.props.option.label);
    }
  }, {
    key: "renderIcon",
    value: function renderIcon() {
      if (this.props.multiple) {
        return /*#__PURE__*/React.createElement(CheckboxView, {
          checked: !!this.props.selected,
          className: styles['checkbox']
        });
      }

      return this.props.selected && /*#__PURE__*/React.createElement(CheckIcon, {
        __classNames: styles['icon'],
        custom: {
          size: '12'
        },
        styles: {
          color: '2B87DB'
        }
      });
    }
  }]);

  return SelectPopupOption;
}(React.Component);